import * as React from 'react';
import DefaultIcon from './DefaultIcon';
export default (props) => (React.createElement(DefaultIcon, Object.assign({}, props, { viewBox: "0 96 960 960" }),
    React.createElement("path", { d: "M200 936v-80h560v80H200Zm280-160q-101 0-157-63t-56-167V216h103v336q0 56 28 91t82 35q54 0 82-35t28-91V216h103v330q0 104-56 167t-157 63Z" })));
